module.exports = __webpack_public_path__ + "static/img/gbInspection.006a7a4e.png";